import React, { useEffect, useState, useCallback } from 'react'
import { NonSerializableDataGrid } from './NonSerializableDataGrid'
import { AddNonSerializedInventoryPane } from './AddNonSerializedInventoryPane'
import { useDispatch } from 'react-redux'
import * as components from '../../components'
import * as rest from '../../services'
import { showErrorToast } from '../../state/toasts'

export const NonSerializableInventoryListPage = (props) => {
  const dispatch = useDispatch()
  const [gridData, setGridData] = useState({})
  const [getAPIResults, setGetAPIResult] = useState(null)
  const handleTableChange = (type, { page, sizePerPage }) => {
    const paginationFilters = {
      ...gridData,
      page: page,
      page_size: sizePerPage,
    }
    setGridData(paginationFilters)
  }
  const onFilter = (data) => {
    const searchFilters = data ? { ...data, page: 1 } : gridData
    setGridData({ ...searchFilters })
  }
  const getData = useCallback(
    (data) => {
      let finalPayload = { ...gridData, ...data }
      setGetAPIResult(null)
      new rest.SerializableInventoryService()
        .makeGetRequest(finalPayload)
        .then((response) => {
          setGetAPIResult(response)
        })
        .catch((errors) => {
          dispatch(
            showErrorToast(
              'Could not get Serializable Inventory list data',
              errors.response.data
            )
          )
        })
    },
    [dispatch, gridData]
  )
  useEffect(() => {
    getData()
  }, [getData, dispatch])
  return !getAPIResults ? (
    <components.Loading />
  ) : (
    <>
      <NonSerializableDataGrid
        handleTableChange={handleTableChange}
        onFilter={onFilter}
        getData={getData}
        results={getAPIResults.results}
        pageSize={getAPIResults.page_size}
        count={getAPIResults.count}
        current={getAPIResults.current}
      >
        <AddNonSerializedInventoryPane
          onSubmit={(data) => {
            getData()
          }}
          title="Add Non Serialized Inventory"
        />
      </NonSerializableDataGrid>
    </>
  )
}
